export enum StoredDocumentsMode {
  None, // File upload
  CategoryManagement,
  FileEdition,
}
